/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const AngleLeftSmall: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path d='M9.70711 5.70711C10.0976 5.31658 10.0976 4.68342 9.70711 4.29289C9.31658 3.90237 8.68342 3.90237 8.29289 4.29289L5.29289 7.29289C4.90237 7.68342 4.90237 8.31658 5.29289 8.70711L8.29289 11.7071C8.68342 12.0976 9.31658 12.0976 9.70711 11.7071C10.0976 11.3166 10.0976 10.6834 9.70711 10.2929L7.41421 8L9.70711 5.70711Z' />
		</Svg>
	);
};

export { AngleLeftSmall };
